<template>
  <div>
    <div class="text-xs-center mt-4 mb-4" v-if="loading">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>
    <div v-else-if="user">
      <customer-detail v-model="user">
        <div slot="header">&nbsp;</div>
      </customer-detail>
    </div>
    <div v-else>
      <div class="text-xs-center mt-4 mb-4">
        <v-icon x-large>error_outline</v-icon>
        <p>No detail</p>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import CustomerDetail from '@/components/view/dashboard/CustomerDetail'
export default {
  props: ['value'],
  components: {
    CustomerDetail
  },
  data: function() {
    return {
      loading: true,
      user: undefined,
      chatboxHeight: 0
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  mounted: function() {
    var vm = this

    vm.loading = true
    vm.getUser(vm.value.userid).then(
      function(user) {
        if (user) {
          vm.user = user
        }
        vm.loading = false
      },
      function(error) {
        vm.loading = false
      }
    )
  },
  methods: {
    onResizeChatbox: function() {
      var vm = this
      setTimeout(() => {
        vm.chatboxHeight = window.innerHeight - document.getElementById('main_toolbar').clientHeight
        if (document.getElementById('chatinput')) {
          vm.chatinputHeight = document.getElementById('chatinput').clientHeight
        }
      }, 500)
    },
    getUser: function(userid) {
      var vm = this
      return new Promise((resolve, reject) => {
        var data = {
          userid: userid,
          pageid: vm.selectedBot.pageid
        }
        api.getUser(data, function(error, response) {
          if (error) {
            reject(error)
          }

          if (response.data) {
            resolve(response.data[0])
          } else {
            resolve(undefined)
          }
        })
      })
    }
  },
  watch: {
    value: function(newVal) {
      var vm = this

      if (newVal == null) {
        vm.user = undefined
      } else {
        vm.loading = true

        vm.getUser(newVal.userid).then(
          function(user) {
            if (user) {
              vm.user = user
            }
            vm.loading = false
          },
          function(error) {
            vm.loading = false
          }
        )
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/livechat/livechat-customers.vue